import script from "./gotop.vue?vue&type=script&setup=true&lang=js"
export * from "./gotop.vue?vue&type=script&setup=true&lang=js"

import "./gotop.vue?vue&type=style&index=0&id=78d1f36d&lang=scss"

const __exports__ = script;

export default __exports__